import React from "react";
import { ArrowRightCircle, CheckCircle2 } from "lucide-react";
import ClipLoader from "react-spinners/ClipLoader";

import { Meeting, SessionAnalysis } from "../../../../../types/supabase";

interface MeetingSummaryProps {
  meeting: Meeting;
  analysis: SessionAnalysis;
}

export const MeetingSummary: React.FC<MeetingSummaryProps> = ({
  meeting,
  analysis,
}) => {
  return (
    <div className="rounded-xl bg-white p-6 shadow-sm">
      <h2 className="mb-4 text-2xl font-semibold">
        Great job mentoring, {meeting.mentor?.vincer_base_user.name}! Here are
        key takeaways with your session with{" "}
        {meeting.mentee?.vincer_base_user.name}:
      </h2>

      <div className="mb-4 text-green-600">
        Session on{" "}
        {new Date(meeting.scheduled_time).toLocaleDateString("en-US", {
          day: "numeric",
          month: "long",
        })}
      </div>

      <div className="mb-6 flex items-start gap-4">
        <div>
          <div className="text-gray-800">
            {analysis?.content?.summary ? (
              <p className="mb-2 text-gray-600">{analysis?.content?.summary}</p>
            ) : (
              <div className="flex h-full flex-col items-center justify-center">
                <ClipLoader color="#000" size={10} />
                <p className="mb-6 text-gray-600">Loading...</p>
              </div>
            )}
          </div>
          <div className="text-green-600">
            {meeting.duration}-minute call with{" "}
            {meeting.mentee?.vincer_base_user.name}
          </div>
        </div>
      </div>

      <div className="space-y-2">
        <h3 className="text-xl font-semibold text-gray-900">Key Insights</h3>
        <div className="flex flex-col space-y-2">
          {analysis?.content?.key_topics &&
            analysis?.content?.key_topics.map((theme) => (
              <span key={theme} className="flex items-center gap-2 text-sm">
                <CheckCircle2 className="size-8 text-green-500" />
                <span className="rounded-full px-3 py-1 text-lg">
                  {theme.charAt(0).toUpperCase() + theme.slice(1)}
                </span>
              </span>
            ))}
        </div>
      </div>
      <div className="mt-5 rounded-lg bg-white">
        <h2 className="mb-4 text-xl font-semibold">Next Steps</h2>
        <div className="space-y-3">
          {analysis?.content?.next_steps?.map((step, index) => (
            <div key={index} className="flex items-start">
              <ArrowRightCircle className="mr-3 size-6 shrink-0 text-blue-400" />
              <p className="text-gray-700">{step}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
